import React, { useState, useEffect } from "react";
import { getStockBal } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";

const Report = () => {
  const { access_token } = useSelector(authSelector);
  const [dateEntered, setDateEntered] = useState("");
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const setDate = (e) => {
    setDateEntered(e.target.value);
  };
  const [itemsQueue, setItemsQueue] = useState([]);

  const [loading, setLoading] = useState(false);
  const editHandler = async (e) => {
    if (!dateEntered) return message.error("Please type date !");
    let data = {
      mEdt: dateEntered,
    };
    try {
      setLoading(true); // disable button
      const results = await getStockBal(data, access_token);
      if (results.success) {
        const payload = results.data.reduce((acc, curr) => {
          return [
            ...acc,
            {
              enteredOn: curr.enteredOn,
              itemCode: curr.itemCode,
              itemName: curr.itemName,
              quantity: Number(curr.quantity),
              purchaseRate: Number(curr.rate),
            },
          ];
        }, []);
        setItemsQueue(payload);
        generatePDF(payload);
      } else {
        message.error(results.message);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    } finally {
      setLoading(false); // re-enable button
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    getName();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.error("No data to generate report!");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");

    // ====== Header ======
    const now = new Date();
    const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    doc.setFontSize(8);
    doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
    doc.setFontSize(16);
    doc.text(`${siteName}`, 103, 11, { align: "center" });
    doc.setFontSize(12);
    doc.text(`${siteAddress}`, 103, 16, { align: "center" });
     doc.setFontSize(10);
    doc.text(
      `Stock Balance Date: ${formatDate(
        dateEntered
      )}`,
      103,
      20,
      {
        align: "center",
      }
    );

    // ====== Table Rows ======
    const tableRows = [];
    let totalAmount = 0;

    const otherRows = data.sort(
      (a, b) => new Date(a.itemCode) - new Date(b.itemCode)
    );

    otherRows.forEach((r) => {
      const amount = Number(r.quantity) * Number(r.purchaseRate) || 0;
      totalAmount += amount;

      tableRows.push([
        r.enteredOn ? formatDateDDMMYYYY(r.enteredOn) : "",
        r.itemCode || "",
        r.itemName || "",
        r.quantity?.toLocaleString() || "",
        r.purchaseRate?.toLocaleString() || "",
        amount.toLocaleString(),
      ]);
    });

    // ====== Add Total Row ======
    tableRows.push([
      { content: "Total", colSpan: 5, styles: { halign: "right" } },
      totalAmount.toLocaleString(),
    ]);

    // ====== Render AutoTable ======
    autoTable(doc, {
      head: [["Date", "Item Code", "Item Name", "Quantity", "Rate", "Amount"]],
      body: tableRows,
      startY: 23,
      theme: "grid",
      margin: { left: 10, right: 10 },
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        valign: "middle",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 25 },
        1: { halign: "center", cellWidth: 20 },
        2: { halign: "left", cellWidth: 60 },
        3: { halign: "right", cellWidth: 25 },
        4: { halign: "right", cellWidth: 23 },
        5: { halign: "right", cellWidth: 30 },
      },
      didParseCell: (hookData) => {
        // Bold last row (Total row)
        if (hookData.row.index === tableRows.length - 1) {
          hookData.cell.styles.fontStyle = "bold";
        }
      },
    });

    // ====== Open PDF in new tab ======
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-32">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className=" text-white">STOCK BALENCE</h1>
              </div>
              <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                <div>
                  <label className="text-white" for="fname">
                    Date:
                  </label>
                  <input
                    type="date"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    onChange={setDate}
                  />
                </div>
                <div>
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                    clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report;
